class QuickViewDrawer extends MenuDrawer {
  constructor() {
    super();

    this.setClasses({
      open: 'quick-view--open',
      opening: 'quick-view--opening',
      closing: 'quick-view--closing'
    });

    this.addEventListener('close', () => {
      const drawerContent = this.querySelector('.quick-view__content');
      const quickView = this.querySelector('quick-view');

      if (quickView && typeof quickView.reset === 'function') {
        quickView.reset();
      } else if (drawerContent) {
        drawerContent.innerHTML = '';
        drawerContent.classList.remove('hide-cover');
      }

      document.dispatchEvent(new CustomEvent('quickview:close'));
    });
  }
}
if (!customElements.get('quick-view-drawer')) {
  customElements.define('quick-view-drawer', QuickViewDrawer);
}

class QuickViewButton extends MenuDrawer {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const wrapper = this.closest('.card-wrapper');
      const drawer = wrapper && wrapper.querySelector('quick-view-drawer');
      if (drawer) {
        closeOtherQuickViewDrawers(drawer);
        const summary = drawer.querySelector('summary');
        const quickView = syncQuickViewProduct(drawer, this.dataset.productUrl);
        if (summary) summary.click();
        if (quickView && typeof quickView.load === 'function') quickView.load();

        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: {
            productUrl: this.dataset.productUrl
          }
        }));
      }
      else if (this.dataset.productUrl) {
        window.location = this.dataset.productUrl;
      }
    });
  }
}
if (!customElements.get('quick-view-button')) {
  customElements.define('quick-view-button', QuickViewButton);
}

function openQuickViewFromTrigger(trigger) {
  const wrapper = trigger && trigger.closest('.card-wrapper');
  const drawer = wrapper && wrapper.querySelector('quick-view-drawer');

  if (!drawer) {
    if (trigger && trigger.dataset.productUrl) window.location = trigger.dataset.productUrl;
    return;
  }

  closeOtherQuickViewDrawers(drawer);

  const summary = drawer.querySelector('summary');
  const quickView = syncQuickViewProduct(drawer, trigger.dataset.productUrl);

  if (summary) summary.click();
  if (quickView && typeof quickView.load === 'function') quickView.load();

  document.dispatchEvent(new CustomEvent('quickview:open', {
    detail: {
      productUrl: trigger.dataset.productUrl || ''
    }
  }));
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-quick-view-button]');
  if (!trigger) return;

  event.preventDefault();
  event.stopPropagation();
  openQuickViewFromTrigger(trigger);
});

function closeOtherQuickViewDrawers(activeDrawer) {
  document.querySelectorAll('quick-view-drawer').forEach((drawer) => {
    if (drawer === activeDrawer) return;

    const details = drawer.querySelector('details[open]');
    if (!details) return;

    const summary = details.querySelector('summary');
    if (typeof drawer.closeMenuDrawer === 'function') {
      drawer.closeMenuDrawer({ type: 'quickview:switch' }, summary || false);
      return;
    }

    details.removeAttribute('open');
    drawer.dispatchEvent(new CustomEvent('close'));
  });
}

function syncQuickViewProduct(drawer, productUrl) {
  const quickView = drawer && drawer.querySelector('quick-view');
  if (!quickView) return null;

  if (productUrl && quickView.dataset.productUrl !== productUrl) {
    quickView.dataset.productUrl = productUrl;
    if (typeof quickView.reset === 'function') quickView.reset();
  }

  return quickView;
}

function buildQuickViewUrl(productUrl) {
  if (!productUrl) return '';

  const currentUrl = new URL(window.location.href);
  const parsedUrl = new URL(productUrl, currentUrl.origin);
  parsedUrl.searchParams.set('view', 'modal');

  return parsedUrl.toString();
}

class QuickView extends HTMLElement {
  constructor() {
    super();

    this.abortController = null;
    this.isLoaded = false;
    this.isLoading = false;

    this.observer = new IntersectionObserver(this.handleIntersection.bind(this));
    this.observer.observe(this);
  }

  handleIntersection(entries, _observer) {
    if (!entries[0].isIntersecting) return;
    this.load();
  }

  load() {
    if (this.isLoaded || this.isLoading) return;

    const selector = '.quick-view__content';
    const drawerContent = this.querySelector(selector);
    if (!drawerContent || !this.dataset.productUrl) return;

    const sectionUrl = buildQuickViewUrl(this.dataset.productUrl);
    if (!sectionUrl) return;

    this.abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
    this.isLoading = true;

    fetch(sectionUrl, this.abortController ? { signal: this.abortController.signal } : undefined)
      .then(response => response.text())
      .then(responseText => {
        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
        const productElement = responseHTML.querySelector(selector);

        if (!productElement) {
          throw new Error('Quick view content was not found.');
        }

        this.setInnerHTML(drawerContent, productElement.innerHTML);

        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        setTimeout(() => {
          drawerContent.classList.add('hide-cover');
          this.isLoaded = true;
          this.isLoading = false;

          document.dispatchEvent(new CustomEvent('quickview:loaded', {
            detail: {
              productUrl: this.dataset.productUrl
            }
          }));
        }, 120);
      })
      .catch(e => {
        this.isLoading = false;
        if (e.name !== 'AbortError') console.error(e);
      });
  }

  reset() {
    if (this.abortController) this.abortController.abort();
    const drawerContent = this.querySelector('.quick-view__content');

    if (drawerContent) {
      drawerContent.innerHTML = '';
      drawerContent.classList.remove('hide-cover');
    }

    this.abortController = null;
    this.isLoaded = false;
    this.isLoading = false;
  }

  setInnerHTML(element, html) {
    element.innerHTML = html;

    // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    element.querySelectorAll('script').forEach(oldScriptTag => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach(attribute => {
        newScriptTag.setAttribute(attribute.name, attribute.value)
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}
if (!customElements.get('quick-view')) {
  customElements.define('quick-view', QuickView);
}
